// Feature-flag readers for the Adaptive Sampling feature.
//
// Phase 1: oracle mode is always on by default — it drives the X-57
// validation flow. Phase 2: this module will read from Thread's
// feature-flag service (not yet wired). The Vite env override exists so
// Playwright harnesses and local debugging can pin the flag on/off.

import { FEATURE_FLAG_ORACLE_MODE } from './types';

export function isOracleModeEnabled(): boolean {
  const override = import.meta.env.VITE_ADAPTIVE_SAMPLING_ORACLE;
  if (override === 'false') return false;
  return true;
}

// Optional fast-path override for the E2E harness. The mock sampler
// honours this to shrink simulated per-point latency so the 30-point
// acceptance campaign completes within a single Playwright test budget.
export function isFastModeEnabled(): boolean {
  const override = import.meta.env.VITE_ADAPTIVE_SAMPLING_FAST;
  return override === 'true';
}

// Convenience: true when the UI is running against the in-memory mock
// sampler instead of the real thread-api backend.
export function isMockModeEnabled(): boolean {
  const override = import.meta.env.VITE_ADAPTIVE_SAMPLING_MOCK;
  return override === 'true';
}

export { FEATURE_FLAG_ORACLE_MODE };
